var render, staticRenderFns
import script from "./CbsContextMenu.vue?vue&type=script&lang=js&"
export * from "./CbsContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./CbsContextMenu.vue?vue&type=style&index=0&id=714e2a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714e2a96",
  null
  
)

export default component.exports